// extracted by mini-css-extract-plugin
export default {"title":"download-agent-installer_title__9lKLS","downloadButton":"download-agent-installer_downloadButton__OSf8k","buttonContent":"download-agent-installer_buttonContent__v6cXG"};